import MainWrapper from './components/MainWrapper.svelte';
import { mount } from 'svelte';

const loadRecommendationsForAddOnSales = ({ target, variationId, eventMergeId }) => {
  mount(MainWrapper, {
    target,
    props: {
      featureIndex: target.parentNode.dataset.featureOrder || '99',
      variationId,
      eventMergeId,
      errorCallback: () => target.remove()
    }
  });
  return Promise.resolve();
};
window.o_reco = window.o_reco || {};
window.o_reco.api = window.o_reco.api || {};
window.o_reco.api.loadRecommendationsForAddOnSales = loadRecommendationsForAddOnSales;

window.otto?.reco?.addOnSales?.renderRecommendations?.assignFunction(
  loadRecommendationsForAddOnSales
);

window.o_global.eventQBus.emitModuleLoaded('ft6bcn.reco-aos-frontend.assets');
